import { render } from "./HomeGameElement.vue?vue&type=template&id=096cedc5&scoped=true"
import script from "./HomeGameElement.vue?vue&type=script&lang=js"
export * from "./HomeGameElement.vue?vue&type=script&lang=js"

import "./HomeGameElement.vue?vue&type=style&index=0&id=096cedc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096cedc5"]])

export default __exports__